import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCavityPump = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 123.77,
	height: 35,
	viewBox: "0 0 123.77 35.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 87.0 0.0 A 20.0 20.0 0.0 0 0 87.0 30.0 L 117.0 30.0 A 20.0 20.0 0.0 0 0 117.0 0.0 Z M 75.0 15.0 L 80.0 15.0 M 15.0 25.0 L 15.0 35.0 M 60.0 25.0 L 60.0 35.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 5,
			width: 75,
			height: 20,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 4.5 15.0 A 6.0 10.0 0.0 0 1 15.5 15.0 A 6.0 10.0 0.0 0 0 26.5 15.0 A 6.0 10.0 0.0 0 1 37.5 15.0 A 6.0 10.0 0.0 0 0 48.5 15.0 A 6.0 10.0 0.0 0 1 59.5 15.0 A 6.0 10.0 0.0 0 0 70.5 15.0 M 87.0 0.0 L 87.0 30.0 M 117.0 0.0 L 117.0 30.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgCavityPump;
